// replace \\n with \n to display the text correctly in the Box component
export const formatTextWithHtml = (text) => {
    return (text === null || text === void 0 ? void 0 : text.replace(/\\n/g, "\n")) || text;
};
